<template>
  <div class="consultTeacherMain">
    <!-- 老师列表 -->
    <div
      @click="toDetail(item)"
      v-show="showType == 1"
      v-for="(item, index) in teacherList"
      :key="index"
      class="cell"
    >
      <img class="headerImg" :src="item.header" />
      <span class="name">{{ item.wx_nick_name }}</span>
      <span class="red-point" v-if="item.showRedPoint"></span>
      <img class="btn" src="../../assets/imgs/zhixun.png" />
      <span class="unReadText" v-if="item.unRead > 0">{{ item.unRead }}</span>
    </div>
    <div class="messageMain" v-show="showType == 2">
      <div class="header">
        <img
          @click="backList"
          class="back"
          src="../../assets/imgs/liaotian_back.png"
        />
        <span @click="backList">返回列表</span>
      </div>
      <div id="messageBox" class="messageBox">
        <div
          v-for="(item, index) in messageList"
          class="messageCell"
          :key="index"
        >
          <div>
            <div class="messageHeader other">
              <img :src="item.header" />
              <span class="name">{{ item.nick }}</span>
              <span class="time">{{ item.create_time }}</span>
            </div>
          </div>
          <div class="talkbox">
            <div class="content" v-dompurify-html="item.content"></div>
            <div v-if="item.pic_url" class="contentImg">
               <el-image
                      class="commentimg"
                      style="margin-top: 5px"
                       v-if="item.pic_url"
                      :src="item.pic_url"
                      :preview-src-list="[item.pic_url]">
                    </el-image>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
/* eslint-disable standard/no-callback-literal */

import tool from '@/kits/Tools.js'
import handleim from '@/kits/im/handleim.js'
import qs from 'qs'

export default {
  props: {
    dsId: {
      type: Number | String,
      default: 0
    },
    fansId: {
      type: Number | String,
      default: 0
    },
    tid: {
      type: Number | String,
      default: 0
    },
    channel_id: {
      type: Number | String,
      default: 0
    }
  },
  watch: {
    dsId (to) {
      if (to) {
        this.getTeacherList()
      }
    },
    showType (to) {
      this.switchTimeList()
    }
  },
  data () {
    return {
      timer: null,
      teacherList: [],
      showType: 1,
      selectItem: null,
      messageList: []
    }
  },
  created () {},
  methods: {
    stopTimeList () {
      clearInterval(this.timer)
      this.timer = null
    },
    switchTimeList () {
      if (this.showType === 1) {
        this.startTimeList()
      } else if (this.showType === 2) {
        this.stopTimeList()
      }
    },
    onReceivedMsg (json) {
      if (this.showType === 1) {
        this.teacherList.forEach((item) => {
          if (item.fans_id === json.fans_id) {
            item.unRead = item.unRead + 1
          }
        })
        return
      }

      if (
        this.showType === 2 &&
        this.selectItem &&
        `${json.fans_id}` === `${this.selectItem.fans_id}`
      ) {
        this.messageList.push(json)
        this.$nextTick(() => {
          let chatContent = document.getElementById('messageBox')
          chatContent.scrollTop = chatContent.scrollHeight
        })
      }
    },
    sendC2CMsg (comment, occupyImg, callback) {
      if (!this.selectItem) {
        if (callback) {
          callback(false, '请选择老师后发送消息')
        }
      } else {
        const param = {
          ds_id: this.dsId,
          to: this.selectItem.fans_id,
          fans_id: this.fansId,
          content: comment,
          pic_url: occupyImg,
          terminal_type: 2
        }
        if (this.tid) {
          param.tid = this.tid
        }
        let self = this
        this.axios
          .post(
            tool.baseUrl2() + '/api/comment/index/addC2C',
            qs.stringify(param)
          )
          .then(function (data) {
            callback(true)
            self.messageList.push(data.data.data.content)
            setTimeout(() => {
              let chatContent = document.getElementById('messageBox')
              chatContent.scrollTop = chatContent.scrollHeight
            }, 50)
            handleim.onSendP2PMsg(
              data.data.data.content,
              self.selectItem.fans_id
            )
          })
          .catch(function (data) {
            callback(false, '网络错误')
          })
      }
    },
    backList () {
      this.showType = 1
    },
    toDetail (item) {
      item.showRedPoint = false
      this.selectItem = item
      item.unRead = 0
      this.showType = 2
      this.getMessageList()
    },
    startTimeList () {
      this.getTeacherList()
      if (this.timer) {
        clearInterval(this.timer)
        this.timer = null
      }
      this.timer = setInterval(() => {
        this.getTeacherList()
      }, 10000)
    },
    getTeacherList () {
      const param = {
        ds_id: this.dsId,
        channel_id: this.channel_id
      }
      if (this.tid) {
        param.tid = this.tid
      }
      let self = this
      this.axios
        .post(
          tool.baseUrlUser() + '/app/index/getOnlineTeacherList',
          qs.stringify(param)
        )
        .then(function (data) {
          if (data.data.code === 200) {
            const tList = []
            data.data.data.list.forEach((element) => {
              const item = self.teacherList.find((item) => {
                return item.fans_id === element.fans_id
              })
              element.unRead = item && item.unRead ? item.unRead : 0
              element.showRedPoint = item && item.showRedPoint ? item.showRedPoint : false
              tList.push(element)
            })
            self.teacherList = tList
          }
        })
        .catch(function (data) {})
    },
    getMessageList () {
      const param = {
        ds_id: this.dsId,
        fans_id: this.fansId,
        to: this.selectItem.fans_id
      }
      if (this.tid) {
        param.tid = this.tid
      }
      let self = this
      this.axios
        .post(
          tool.baseUrl2() + '/api/comment/index/getC2CHistory',
          qs.stringify(param)
        )
        .then(function (data) {
          if (data.data.code === 200) {
            self.messageList = data.data.data
            setTimeout(() => {
              let chatContent = document.getElementById('messageBox')
              chatContent.scrollTop = chatContent.scrollHeight
            }, 50)
          }
        })
        .catch(function (data) {})
    },
    /**
     * 描述：私聊时标记未读老师小红点
    **/
    setRedPointToTeacher (id) {
      this.teacherList = this.teacherList.map(item => {
        if (item.fans_id == id && !(this.showType === 2 && this.selectItem.fans_id == id)) {
          return {
            ...item,
            showRedPoint: true
          }
        } else {
          return {
            ...item,
            showRedPoint: false
          }
        }
      })
    }
  }
}
</script>

<style scoped>
.consultTeacherMain {
  width: 100%;
  height: 100%;
  overflow: auto;
}

.consultTeacherMain .header {
  height: 40px;
  border-bottom: #f5f5f5 solid 1px;
  position: relative;
}

.consultTeacherMain .header .back {
  width: 24px;
  position: absolute;
  top: 6px;
  left: 16px;
  cursor: pointer;
}

.consultTeacherMain .header span {
  position: absolute;
  top: 14px;
  left: 47px;
  color: white;
  cursor: pointer;
}

.consultTeacherMain .cell {
  position: relative;
  height: 50px;
  width: 100%;
  border-bottom: #f5f5f5 solid 1px;
  cursor: pointer;
}

.consultTeacherMain .cell .headerImg {
  position: absolute;
  width: 30px;
  height: 30px;
  top: 10px;
  left: 10px;
  border-radius: 15px;
}

.consultTeacherMain .cell .red-point {
  position: absolute;
  top: 12px;
  right: 10px;
  padding: 5px;
  background-color: red;
  border-radius: 50%;
}

.consultTeacherMain .cell .unReadText {
  color: aliceblue;
  display: inline-block;
  position: absolute;
  top: 16px;
  right: 50px;
  padding: 5px;
  text-align: center;
  background-color: red;
  border-radius: 10px;
  font-size: 12px;
}

.consultTeacherMain .cell .name {
  position: absolute;
  top: 20px;
  left: 56px;
  color: white;
}

.consultTeacherMain .cell .btn {
  position: absolute;
  width: 20px;
  height: 20px;
  top: 16px;
  right: 20px;
}

.messageMain {
  height: 100%;
  width: 100%;
}

.messageBox {
  padding-top: 1px;
  /* overflow-y: auto; */
  overflow-x: hidden;
  height: calc(100% - 42px);
}

.messageCell {
  margin-top: 5px;
  margin-bottom: 5px;
}

.messageCell .messageHeader {
  height: 40px;
  position: relative;
  color: white;
}

.messageHeader .time {
  font-size: 12px;
  position: absolute;
  top: 9px;
  right: 16px;
}

.messageHeader .name {
  font-size: 14px;
  position: absolute;
  top: 9px;
  left: 42px;
}

.messageCell .messageHeader img {
  height: 30px;
  position: absolute;
  width: 30px;
  border-radius: 15px;
}

.messageCell .other {
  top: 5px;
  left: 10px;
}

.messageCell .self img {
  top: 5px;
  right: 10px;
}

.messageCell .self .name {
  top: 13px;
  right: 50px;
  text-align: right;
}

.messageCell .self .time {
  top: 12px;
  left: 10px;
}

.messageCell .content {
  color: white;
  /* padding-left: 48px; */
  word-wrap: break-word;
  word-break: normal;
  line-height: 20px;
  white-space: pre-line;
  /* padding-right: 20px; */
}

.messageCell .right {
  text-align: right;
  padding-right: 48px;
  padding-left: 20px;
}
.contentImg img {
  position: static;
  max-width: 180px;
  /* margin-left: 40px; */
}

.contentImg .rightImg {
  margin-left: 40px;
}
.talkbox {
  line-height: 20px;
  margin-left: 40px;
  display: inline-block;
  padding: 10px;
  border-radius: 5px;
  background-color: rgb(87, 84, 85);
  color: rgb(255, 255, 255);
  max-width: 80%;
}
</style>



// WEBPACK FOOTER //
// src/components/ConsultTeacher/index.vue